export default __webpack_public_path__ + "static/media/Marcelin Family Signum.e2f086f8.jpg";